// Module
var code = "<!-- ko foreach: _screenRows --> <!-- ko template: { name: $data.GetTemplateName.bind($data), afterRender: $data.AfterRender.bind($data) } --><!-- /ko --> <!-- /ko -->";
// Exports
export default code;